import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { omitTopLevelId } from '#/api/adapters/patchBody';

/**
 * PATCH stock-issue-category：code／name／remark + updated_at。
 */
export async function updateStockIssueCategory(id, payload) {
  const { data: raw } = await request.patch(
    `/system/stock-issue-category/${id}`,
    keysToSnake(omitTopLevelId(payload)),
  );
  return parseVer4DetailResponse(raw);
}
